import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { GoogleIcon, FacebookIcon, AppleIcon } from './SocialIcons';
export const Login: React.FC = () => {
  return <div className="min-h-screen flex items-center justify-center bg-background p-4" data-id="element-320">
      <div className="w-full max-w-md" data-id="element-321">
        <div className="text-center mb-8" data-id="element-322">
          <h1 className="text-3xl font-bold text-primary" data-id="element-323">Divergram</h1>
          <p className="text-gray-600 mt-2" data-id="element-324">Sign in to your account</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6 border border-gray-100" data-id="element-325">
          <form className="space-y-5" data-id="element-326">
            <div data-id="element-327">
              <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-328">
                Email Address
              </label>
              <input type="email" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="your@email.com" required data-id="element-329" />
            </div>
            <div data-id="element-330">
              <div className="flex justify-between items-center mb-1.5" data-id="element-331">
                <label className="block text-sm font-medium text-gray-700" data-id="element-332">
                  Password
                </label>
                <Link to="/forgot-password" className="text-xs text-primary hover:underline" data-id="element-333">
                  Forgot Password?
                </Link>
              </div>
              <input type="password" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors" placeholder="••••••••" required data-id="element-334" />
            </div>
            <Link to="/profile" className="block mt-6" data-id="element-335">
              <Button variant="primary" fullWidth size="lg" data-id="element-336">
                Sign In
              </Button>
            </Link>
          </form>
          <div className="relative flex items-center justify-center my-6" data-id="element-337">
            <div className="border-t border-gray-300 absolute w-full" data-id="element-338"></div>
            <span className="bg-white px-2 text-sm text-gray-500 relative" data-id="element-339">
              Or continue with
            </span>
          </div>
          <div className="grid grid-cols-3 gap-3" data-id="element-340">
            <Button variant="outline" onClick={() => {}} className="flex justify-center items-center" data-id="element-341">
              <GoogleIcon data-id="element-342" />
            </Button>
            <Button variant="outline" onClick={() => {}} className="flex justify-center items-center" data-id="element-343">
              <FacebookIcon data-id="element-344" />
            </Button>
            <Button variant="outline" onClick={() => {}} className="flex justify-center items-center" data-id="element-345">
              <AppleIcon data-id="element-346" />
            </Button>
          </div>
        </div>
        <div className="text-center" data-id="element-347">
          <p className="text-gray-600" data-id="element-348">
            Don't have an account?{' '}
            <Link to="/register" className="text-primary hover:underline font-medium" data-id="element-349">
              Sign Up
            </Link>
          </p>
        </div>
      </div>
    </div>;
};